import styled from 'styled-components';
import Colors from '@/constants/Colors';

export const StyledInteractiveVideoSummary = styled.div`
  position: absolute;
  width: 80%;
  min-width: 500px;
  height: auto;
  max-height: 100%;
  background: white;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 16px;
  border-radius: 4px;
  box-shadow: -2px 3px 15px 2px rgb(0 0 0 / 0.35);
  z-index: 101;

  overflow-y: auto;
  .ant-divider {
    margin: 8px 0;
  }
  .summary-content {
    .details {
      margin: 16px 0;
      .details-header {
        font-weight: bold;
      }
      .answer-detail,
      .details-header {
        display: flex;
        flex-direction: horizontal;
        justify-content: space-between;
        .title {
          width: 60%;
        }
        .correct-answer {
          width: 20%;
        }
        .answer-text {
          width: 20%;

          padding: 0 0.5em;
        }
        .right-answer {
          width: 15%;
        }
      }
      .answer-detail {
        &:nth-child(odd) {
          background-color: ${Colors.darkBackground};
        }
        .correct-answer {
          color: ${Colors.green};
          padding: 0 0.5em;
        }
        .answer-text {
          color: ${Colors.red};
        }
        .right-answer {
          color: ${Colors.green};
        }
      }
    }
  }
  .actions {
    display: flex;
    justify-content: flex-end;
  }
`;
